<template>
  <div class="hint-preview">
    <FakeRating v-if="showed" />
  </div>
</template>

<script>
  import { jsonStylesToCss } from 'src/utils';

  import basePreview from '../../mixins/basePreview';
  import { THEME_TYPE_CLASSIC } from '../../utils';

  import FakeRating from './FakeRating.vue';

  export default {
    name: 'RatingPreview',

    components: {
      FakeRating,
    },

    extends: basePreview,

    computed: {
      compiledCss() {
        const { copyrightHidden } = this.settings;
        const styles = {};

        if (copyrightHidden) {
          styles['hinted-hint-bottom-link'] = 'display:none;';
        }

        let css = jsonStylesToCss(styles).replace(/;|(([^;])(}))/g, '$2 !important; $3');
        css = css.replace(/hinted-hint-bottom-link/gi, 'hinted-hint-bottom-link > *');

        return css;
      },
    },

    watch: {
      type: {
        immediate: true,
        async handler() {
          await this.$nextTick();
          this.updateThemeClasses();
        },
      },

      async showed(value) {
        await this.$nextTick();

        if (value) {
          this.updateThemeClasses();
        }
      },
    },

    methods: {
      updateThemeClasses() {
        const element = document.querySelector('.hinted-feedback-modal');

        if (!element) {
          return;
        }

        if (this.type === THEME_TYPE_CLASSIC) {
          element.classList.add('style-classic');
        } else {
          element.classList.remove('style-classic');
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .hint-preview {
    height: 700px;
    position: relative;
    background-color: rgba(0, 0, 0, 0.8);
  }
</style>
